import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { SchoolInsUpdData } from "./SchoolInsUpdData";
import { SchoolInsUpdReview } from "./SchoolInsUpdReview";
import { schoolInsert, schoolUpdate, schoolInsUpdSlice, selectSchoolInsUpd } from "../../../redux/school/schoolInsUpdSlice";
import ObjectInsUpd from "../../../features/base/page/ObjectInsUpd";
import { schoolsSlice } from "../../../redux/school/schoolsSlice";
import { useParams } from "react-router";
import { schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import PageAuthenticatedLoading from "../../../features/pages/PageAuthenticatedLoading";
import SchoolPageTitle from "../basics/SchoolPageTitle";
import SchoolPageAvatar from "../basics/SchoolPageAvatar";
import { routeSchool } from "../../../routes/school";
import { TopBar } from "../../../features/top/TopBar";

export function SchoolInsUpd() {
    const schoolInsUpd = useSelector(selectSchoolInsUpd);
    const school = useSelector(selectSchool);
    const dispatch = useAppDispatch();

    const {schoolId} = useParams();
    console.debug(`SchoolInsUpd: ${schoolId}`);

    const editing = schoolId !== undefined;
    const breadcrumbTitle = editing ? "Editar Escola" : "Nova Escola";
  
    if(editing) {
        if(schoolInsUpd.school.id === "" && school.selected) {
          const changing = {
            ...school.selected
          };
          dispatch(schoolInsUpdSlice.actions.set(changing));
        }
      }
    
    const breadcrumbs = [ { label: breadcrumbTitle }, ];

    const steps = [
        {
            name: "Dados da escola",
            component: <SchoolInsUpdData />,
            check: () => schoolInsUpd.school.name.length > 4,
        },
        {
            name: "Revisão",
            component: <SchoolInsUpdReview />,
        }
    ];

    const title = (editing) ? <SchoolPageTitle schoolId={schoolId} /> : "Nova escola";
    const pageAvatar = (editing) ? <SchoolPageAvatar /> : undefined;
  
    const buildContent = () => 
        <ObjectInsUpd 
                    name="escola" 
                    submit={() => (editing)
                        ? dispatch(schoolUpdate({school: schoolInsUpd.school, schoolId: schoolId}))
                        : dispatch(schoolInsert({school: schoolInsUpd.school}))
                    } 
                    backTo={
                        (editing)? routeSchool(schoolId, "classroom") : "/"
                    } 
                    backCleanup={() => {
                        dispatch(schoolsSlice.actions.clean());
                        dispatch(schoolInsUpdSlice.actions.clean());
                    }}
                    state={schoolInsUpd.state} 
                    steps={steps}
                    edit={editing}
        />;

        return <PageAuthenticatedLoading key="editUpdateSchool"
            topbar={ <TopBar title={title} pageAvatar={pageAvatar} breadcrumbs={breadcrumbs} /> }
            loading={{
                states: editing ? [school.state] : [], 
                content: buildContent,
                error: "Erro ao carregar escola",
                retry: () => {
                dispatch(schoolSlice.actions.clean());
                }
            }} />;
                
}
